import { render, staticRenderFns } from "./add-to-smart-wallet-button.vue?vue&type=template&id=710470e1&scoped=true"
import script from "./add-to-smart-wallet-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-to-smart-wallet-button.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./add-to-smart-wallet-button.vue?vue&type=style&index=0&id=710470e1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710470e1",
  null
  
)

export default component.exports